const baseURL = '';
const baseAPI = baseURL + '/api';
const baseOAuthURL = baseURL + '/oauth';

export const Const = {
    baseURL: baseURL,
    baseAPI: baseAPI,
    auth: {
        tokenURL: baseOAuthURL + '/token',
        clientId: '2',
        clientSecret: 'UbEh9iLhOOzY5uyVZ21nvTOlHWevBG9XGgy6qAgR',
        defaultScope: '*'
    },
};
